import { create } from 'zustand';
import { authAPI } from '../services/api';

export const useAuthStore = create((set, get) => ({
  user: null,
  token: null,
  isLoading: true,
  isAuthenticated: false,

  login: async (email, password, preferredRole) => {
    const response = await authAPI.login(email, password, preferredRole);
    localStorage.setItem('auth_token', response.access_token);
    set({ token: response.access_token, user: response.user, isAuthenticated: true, isLoading: false });
    return response.user;
  },

  register: async (email, password, role, phone, consent = {}, phoneVerificationToken = null, referralCode = null) => {
    const response = await authAPI.register(email, password, role, phone, consent, phoneVerificationToken, referralCode);
    localStorage.setItem('auth_token', response.access_token);
    set({ token: response.access_token, user: response.user, isAuthenticated: true, isLoading: false });
    return response.user;
  },

  logout: () => {
    localStorage.removeItem('auth_token');
    set({ token: null, user: null, isAuthenticated: false });
  },

  updatePhone: async (phone) => {
    await authAPI.updatePhone(phone);
    const user = await authAPI.getMe();
    set({ user });
  },

  loadUser: async () => {
    try {
      const token = localStorage.getItem('auth_token');
      if (token) {
        const user = await authAPI.getMe();
        set({ token, user, isAuthenticated: true, isLoading: false });
      } else {
        set({ isLoading: false });
      }
    } catch {
      localStorage.removeItem('auth_token');
      set({ token: null, user: null, isAuthenticated: false, isLoading: false });
    }
  },
}));
